import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { CheckIcon } from 'assets/materialIcons/materialIcons';

const OptionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
`;

const OptionButton = styled.div`
    font-size: 13px;
    color: ${ ({ isDelete }) => {
        return isDelete ? theme.palette.redOrange : theme.palette.primary1Color;
    } };

    &:hover {
        cursor: pointer;
    }
`;

const HightlightedImageWrapper = styled.div`
    position: absolute;
    right: 10px;
    top: 10px;
`;

const HighlightedImage = styled.div`
    background: #fff;
    display: flex;
    padding: 5px 10px;
    border-radius: 10px;
    align-items: center;
    justify-content: space-between;

    label {
        font-size: 12px;
        color: ${ theme.palette.primary1Color };
    }

    svg {
        margin-right: 5px;
        height: 14px !important;
        width: 14px !important;
    }
`;

const ImageCard = (props) => {
    const {
        image,
        onDelete,
        onHighlightImage,
        showHighlightOption,
        translate,
    } = props;

    const {
        relationships: {
            imageVersions: {
                data,
            },
        },
        is_highlighted,
        ...payload
    } = image;

    const handleOnHighlightImage = (payload, isHighlighted) => {
        if (utils.isFunction(onHighlightImage)) {
            return onHighlightImage({
                is_highlighted: !isHighlighted,
                ...payload,
            });
        }

        return;
    };

    // Chooses the last version with less size.
    const imageVersionURL = data[2].url;
    const isHighlighted = showHighlightOption && is_highlighted;

    return (
        <div>
            {
                isHighlighted &&
                    <HightlightedImageWrapper>
                        <HighlightedImage>
                            <CheckIcon color={ theme.palette.primary1Color } />
                            <label>{ translate('dropzone.label.highlighted_image') }</label>
                        </HighlightedImage>
                    </HightlightedImageWrapper>
            }

            <img src={ imageVersionURL } />

            <OptionWrapper>
                {
                    isHighlighted ?
                        <OptionButton
                            isDelete={ true }
                            onClick={ () => {
                                return handleOnHighlightImage(payload, isHighlighted);
                            } }
                        >
                            { translate('dropzone.label.remove_highlight') }
                        </OptionButton>
                        :
                        <OptionButton
                            onClick={ () => {
                                return handleOnHighlightImage(payload, isHighlighted);
                            } }
                        >
                            { translate('dropzone.label.highlight_image') }
                        </OptionButton>
                }

                <OptionButton
                    isDelete={ true }
                    onClick={ () => {
                        return onDelete(payload);
                    } }
                >
                    { translate('actions.delete') }
                </OptionButton>
            </OptionWrapper>
        </div>
    );
};

ImageCard.defaultProps = {
    showHighlightOption: false,
};

ImageCard.propTypes = {
    image: PropTypes.shape({
        id: PropTypes.number.isRequired,
        image_id: PropTypes.number.isRequired,
        is_highlighted: PropTypes.bool,
        point_of_interest_id: PropTypes.number,
        product_id: PropTypes.string,
        relationships: PropTypes.shape({
            imageVersions: PropTypes.shape({
                data: PropTypes.array,
            }),
        }),
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
    onHighlightImage: PropTypes.func,
    showHighlightOption: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default translate(ImageCard);


// WEBPACK FOOTER //
// ./src/pages/products/images/ImageCard.js